import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-typed";

import type { Schemas } from "@/types/api";

export type SearchGroup = Schemas["SearchGroup"];

/**
 * Pesquisa global (command palette). Só dispara com >= 2 caracteres.
 * O termo deve vir já debounced pelo chamador. Resultados filtrados por
 * permissões no backend; cada hit traz o `url` de detalhe pronto a navegar.
 */
export const useGlobalSearch = (query: string) =>
  useQuery<SearchGroup[]>({
    queryKey: ["global-search", query],
    queryFn: async () => {
      const res = await api.get("/search", { query: { q: query } });
      return res.groups;
    },
    enabled: query.trim().length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
